var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"iq-answer-view-all",attrs:{"href":_vm.href}},[_c('span',{staticClass:"iq-answer-view-all__label"},[_vm._v("View all "+_vm._s(_vm.total)+" →")])])
}
var staticRenderFns = []

export { render, staticRenderFns }